import boot from './data/01-boot.js';
import freefall from './data/02-freefall.js';
import uplink from './data/03-uplink.js';
import spire from './data/04-spire.js';
import velocity from './data/05-velocity.js';
import descent from './data/06-descent.js';
import cascade from './data/07-cascade.js';
import turbine from './data/08-turbine.js';
import rebound from './data/09-rebound.js';
import aurora from './data/10-aurora.js';
import conflux from './data/11-conflux.js';
import zephyr from './data/12-zephyr.js';
import slipstream from './data/13-slipstream.js';
import fracture from './data/14-fracture.js';
import foundry from './data/15-foundry.js';
import piston from './data/16-piston.js';
import watchtower from './data/17-watchtower.js';
import phosphor from './data/18-phosphor.js';
import skybreak from './data/19-skybreak.js';
import switchback from './data/20-switchback.js';
import crossflow from './data/21-crossflow.js';
import relay from './data/22-relay.js';

/**
 * Campaign order. Adding a sector is one import and one array entry: the menu,
 * progression gating and next-level flow all read from here.
 */
// Chapter 2 sits at the END of the array (so ZEPHYR/SLIPSTREAM keep their
// unlock ancestry for existing saves) but opens off CONFLUX via unlockAfter.
export const LEVELS = [boot, freefall, uplink, spire, velocity, descent, cascade, turbine,
  rebound, aurora, conflux, zephyr, slipstream, fracture, foundry, piston, watchtower, phosphor, skybreak,
  switchback, crossflow, relay];

export const LEVELS_BY_ID = Object.fromEntries(LEVELS.map((l) => [l.id, l]));

export function levelIndex(id) {
  return LEVELS.findIndex((l) => l.id === id);
}

export function nextLevel(id) {
  const i = levelIndex(id);
  return i >= 0 && i < LEVELS.length - 1 ? LEVELS[i + 1] : null;
}

/** A sector unlocks when the one before it has been cleared, unless its
 *  def names a different ancestor (Chapter 2 branches off CONFLUX while
 *  living at the end of the array). */
export function isUnlocked(save, id) {
  const i = levelIndex(id);
  if (i <= 0) return true;
  const after = LEVELS[i].unlockAfter;
  if (after) return save.isCleared(after);
  return save.isCleared(LEVELS[i - 1].id);
}
